import { MenuItem } from "../models/menu.model";

export class Menu {
  public static pagesAdmin: MenuItem[] = [
    {
      group: 'Général',
      separator: true,
      items: [
        {
          icon: 'home',
          label: 'Tableau de bord',
          route: '/admin',
        },
      ]
    },
    {
      group: 'Réseau & Partenaires',
      separator: true,
      items: [
        {
          icon: 'folder',
          label: 'Entreprises',
          route: '/admin/companies',
          routePermission: "BO_COMPANY_LIST",
        },
        {
          icon: 'users',
          label: 'Salariés',
          route: '/admin/employees',
          routePermission: "BO_EMPLOYEE_LIST",
        },
        {
          icon: 'shopping-bag',
          label: 'Marchands',
          route: '/admin/sellers',
          routePermission: "BO_MERCHANT_LIST",
        },
        {
          icon: 'shopping-cart',
          label: 'Boutiques',
          route: '/admin/shops',
          routePermission: "BO_APPLICATION_LIST",
        },
        {
          icon: 'bookmark',
          label: 'Catégories',
          route: '/admin/categories',
          routePermission: "BO_CATEGORY_LIST",
        },
        {
          icon: 'briefcase',
          label: 'Services',
          route: '/admin/services',
          routePermission: 'BO_INSURANCE_LIST_CONTRACT',
        },
      ]
    },
    {
      group: 'Finances',
      separator: true,
      items: [
        {
          icon: 'bar-chart-2',
          label: 'Paiements',
          route: '/admin/payments',
          routePermission: "BO_PAYMENT_LIST",
        },
        {
          icon: 'plus-square',
          label: 'Fonds',
          route: '',
          routePermission: "BO_PAYMENT_LIST",
          children: [
            {
              label: "Appel de fonds",
              route: '/admin/call-funds',
              icon: 'credit-card',
              routePermission: 'BO_PAYMENT_LIST'
            },
            {
              label: "Dépot de fonds",
              route: '/admin/deposit-funds',
              icon: 'repeat',
              routePermission: 'BO_PAYMENT_LIST'
            },
          ]
        },
        {
          icon: 'send',
          label: 'Transferts Internes',
          route: '/admin/internal-transfers',
          routePermission: "BO_INTERNAL_TRANSFER_LIST",
        },
        {
          icon: 'credit-card',
          label: 'Compte Bon',
          route: '/admin/vouchers',
          routePermission: "BO_WALLET_FUND_HISTORY_LIST",
        },
      ]
    },
    {
      group: 'Offres & E-commerce',
      separator: true,
      items: [
        {
          icon: 'star',
          label: 'Prime',
          route: '',
          childPermission1: 'BO_PRIME_VIEW',
          children: [
            {
              icon: 'bar-chart-2',
              label: 'Dashboard',
              route: '/admin/prime/dashboard',
              routePermission: 'BO_PRIME_VIEW'
            },
            {
              icon: 'award',
              label: 'Offres Prime',
              route: '/admin/prime/plans',
              routePermission: 'BO_PRIME_VIEW'
            },
            {
              icon: 'users',
              label: 'Abonnements',
              route: '/admin/prime/subscriptions',
              routePermission: 'BO_PRIME_VIEW'
            }
          ]
        },
        {
          icon: 'globe',
          label: 'E-commerce',
          route: '',
          childPermission1: 'BO_ECOMMERCE_SHOP_LIST',
          childPermission2: 'BO_ECOMMERCE_ORDER_LIST',
          childPermission3: 'BO_ECOMMERCE_PROMO_LIST',
          children: [
            {
              icon: 'shopping-bag',
              label: 'Boutiques',
              route: '/admin/ecommerce/shops',
              routePermission: 'BO_ECOMMERCE_SHOP_LIST'
            },
            {
              icon: 'package',
              label: 'Commandes',
              route: '/admin/ecommerce/orders',
              routePermission: 'BO_ECOMMERCE_ORDER_LIST'
            },
            {
              icon: 'dollar-sign',
              label: 'Taux de Change',
              route: '/admin/ecommerce/fx-rates',
              routePermission: 'BO_ECOMMERCE_FX_LIST'
            },
            {
              icon: 'map-pin',
              label: 'Zones de Livraison',
              route: '/admin/ecommerce/delivery-zones',
              routePermission: 'BO_ECOMMERCE_DELIVERY_LIST'
            },
            {
              icon: 'map',
              label: 'Points de Retrait',
              route: '/admin/ecommerce/pickup-points',
              routePermission: 'BO_ECOMMERCE_PICKUP_LIST'
            },
            {
              icon: 'settings',
              label: 'Paramètres',
              route: '/admin/ecommerce/settings',
              routePermission: 'BO_ECOM_SETTINGS_VIEW'
            }
          ],
        },
      ]
    },
    {
      group: 'Application Mobile',
      separator: true,
      items: [
        {
          icon: 'tablet',
          label: 'Accueil Application',
          route: '',
          childPermission1: 'BO_APPLICATION_LIST',
          childPermission2: 'BO_SLIDER_LIST',
          childPermission3: 'BO_CATEGORY_LIST',
          children: [
            {
              label: "Boutiques d'accueil",
              route: '/admin/home-app/shops',
              icon: 'shopping-cart',
              routePermission: 'BO_APPLICATION_LIST'
            },
            {
              label: "Images d'accueil",
              route: '/admin/home-app/sliders',
              icon: 'image',
              routePermission: 'BO_SLIDER_LIST'
            },
            {
              icon: 'bookmark',
              label: "Catégories d'accueil",
              route: '/admin/home-app/categories',
              routePermission: "BO_CATEGORY_LIST",
            },
          ],
        },
        {
          icon: 'filter',
          label: 'Suggestions',
          route: '',
          childPermission1: 'BO_SUGGEST_LIST_CLIENT',
          childPermission2: 'BO_SUGGEST_LIST_SHOP',
          childPermission3: 'BO_SUGGEST_LIST_COMPANY',
          children: [
            {
              label: 'Non-salariés',
              route: '/admin/suggestions/customers',
              icon: 'users',
              routePermission: 'BO_SUGGEST_LIST_CLIENT'
            },
            {
              label: 'Boutiques',
              route: '/admin/suggestions/shops',
              icon: 'shopping-cart',
              routePermission: 'BO_SUGGEST_LIST_SHOP'
            },
            {
              label: 'Entreprises',
              route: '/admin/suggestions/companies',
              icon: 'folder',
              routePermission: 'BO_SUGGEST_LIST_COMPANY'
            },
          ],
        },
        {
          icon: 'bell',
          label: 'Communication',
          route: '',
          childPermission1: 'BO_NOTIFICATION_LIST',
          childPermission2: 'BO_FLASH_MESSAGE_LIST',
          childPermission3: 'BO_SURVEY_LIST',
          children: [
            {
              icon: 'mail',
              label: 'Notifications',
              route: '/admin/notifications',
              routePermission: 'BO_NOTIFICATION_LIST',
            },
            {
              icon: 'bell',
              label: 'Flash Messages',
              route: '/admin/flash-messages',
              routePermission: 'BO_FLASH_MESSAGE_LIST',
            },
            {
              icon: 'clipboard',
              label: 'Sondages',
              route: '/admin/surveys',
              routePermission: 'BO_SURVEY_LIST',
            },
          ],
        },
      ]
    },
    {
      group: 'Administration',
      separator: true,
      items: [
        {
          icon: 'settings',
          label: 'Centre de contrôle',
          route: '',
          childPermission1: 'BO_CONFIG_LIST',
          childPermission2: 'BO_AUDIT_LIST',
          childPermission3: 'BO_ANALYTICS_LIST',
          children: [
            {
              icon: 'tool',
              label: 'Configurations',
              route: '/admin/configs',
              routePermission: 'BO_CONFIG_LIST',
            },
            {
              icon: 'shield',
              label: 'Audit',
              route: '/admin/audit',
              routePermission: 'BO_AUDIT_LIST',
            },
            {
              icon: 'activity',
              label: 'Analytique (Client)',
              route: '/admin/analytics',
              routePermission: 'BO_ANALYTICS_LIST',
            },
          ]
        },
        {
          icon: 'lock',
          label: 'Gestion des Utilisateurs',
          route: '',
          childPermission1: 'BO_USER_LIST',
          childPermission2: 'BO_ACCOUNT_USER_LIST',
          childPermission3: 'BO_APP_REVIEW_LIST',
          childPermission4: 'BO_MERCHANT_INFLATED_PRICE_LIST',
          children: [
            {
              icon: 'user-plus',
              label: 'Administrateurs',
              route: '/admin/admins',
              routePermission: "BO_USER_LIST",
            },
            {
              icon: 'user',
              label: 'Utilisateurs',
              route: '/admin/users',
              routePermission: "BO_ACCOUNT_USER_LIST",
            },
            {
              icon: 'star',
              label: 'Avis Application',
              route: '/admin/reviews',
              routePermission: "BO_APP_REVIEW_LIST",
            },
            {
              icon: 'store',
              label: 'Avis Boutiques',
              route: '/admin/shop-reviews',
              routePermission: "BO_APP_REVIEW_LIST",
            },
            {
              icon: 'trending-up',
              label: 'Prix gonflés',
              route: '/admin/inflated-prices',
              routePermission: "BO_MERCHANT_INFLATED_PRICE_LIST",
            },
          ],
        },
        {
          icon: 'tag',
          label: 'Rôles',
          route: '/admin/roles',
          routePermission: "BO_ROLE_LIST",
        },
      ]
    }
  ];

  public static pages: MenuItem[] = [
    {
      group: 'Général',
      separator: true,
      items: [
        {
          icon: 'home',
          label: 'Tableau de bord',
          route: '/company',
        },
      ]
    },
    {
      group: 'Achats & Finances',
      separator: true,
      items: [
        {
          icon: 'shopping-bag',
          label: 'Achats',
          route: '/company/purchases',
          routePermission: "COMPANY_ACHAT_LIST",
        },
        {
          icon: 'archive',
          label: 'Plafond',
          route: '/company/increases',
          routePermission: "COMPANY_PLAFOND_LIST",
        },
        {
          icon: 'credit-card',
          label: 'Compte Bon',
          route: '/company/vouchers',
          routePermission: "COMPANY_EMPLOYEE_FUND_VOUCHER",
        },
      ]
    },
    {
      group: 'Administration',
      separator: true,
      items: [
        {
          icon: 'user',
          label: 'Salariés',
          route: '/company/employees',
          routePermission: "COMPANY_EMPLOYEE_LIST",
        },
        {
          icon: 'users',
          label: 'Utilisateurs',
          route: '/company/users',
          routePermission: "COMPANY_USER_LIST",
        },
        {
          icon: 'tag',
          label: 'Rôles',
          route: '/company/roles',
          routePermission: "COMPANY_ROLE_LIST",
        },
      ],
    }
  ]
}


//
// [
//   {
//     "id": "074cfab5-f88f-4e86-b8f9-2cf7fd50ee92",
//     "code": "BO_CATEGORY_LIST",
//     "name": "Lister Catégorie",
//     "group": "BO_CATEGORY",
//     "plateform": "BACKOFFICE_ADMIN",
//     "state": "ACTIVE"
//   },
//   {
//     "id": "1be36925-230f-4fc5-9cd7-399ceaf7f149",
//     "code": "BO_CATEGORY_UPDATE",
//     "name": "Modifier Catégorie",
//     "group": "BO_CATEGORY",
//     "plateform": "BACKOFFICE_ADMIN",
//     "state": "ACTIVE"
//   },
//   {
//     "id": "f23640c0-fbfa-41a7-97ac-464ada05d06e",
//     "code": "BO_CATEGORY_CREATE",
//     "name": "Ajouter Catégorie",
//     "group": "BO_CATEGORY",
//     "plateform": "BACKOFFICE_ADMIN",
//     "state": "ACTIVE"
//   },
//   {
//     "id": "f59884d4-ff7b-4439-8a66-1cd37f95f79d",
//     "code": "BO_CATEGORY_SHOW",
//     "name": "Voir Catégorie",
//     "group": "BO_CATEGORY",
//     "plateform": "BACKOFFICE_ADMIN",
//     "state": "ACTIVE"
//   }
// ]
